import React from 'react';
import { ShieldCheck, Activity, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const PreventiveCarePage = () => {
  const config = {
    badge: "Preventive Health",
    headline: "Proactive",
    headlineItalic: "Preventive Care.",
    subtext: "The most powerful medicine is prevention. Our comprehensive preventive care programs protect your pet's health before disease takes hold.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Preventive Pet Care at Dr. Suresh Pet Care — Proactive Health Management",
    stats: [
      { value: 12000, suffix: '+', label: 'Prevention Plans' },
      { value: 80, suffix: '%', label: 'Disease Prevention Rate' },
      { value: 10, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Health Support' },
    ],
    services: [
      {
        title: "Parasite Control",
        icon: <ShieldCheck size={28} />,
        desc: "Year-round protection against fleas, ticks, heartworm, and intestinal parasites with evidence-based protocols.",
        specs: ["Flea & Tick Control", "Heartworm Prevention", "Deworming Protocol", "Seasonal Adjustments"],
        color: "from-green-500/10 to-primary/10"
      },
      {
        title: "Annual Screenings",
        icon: <Activity size={28} />,
        desc: "Comprehensive annual bloodwork and organ screening to baseline your pet's health and catch disease early.",
        specs: ["CBC & Chemistry", "Thyroid Screening", "Urinalysis", "Senior Organ Panel"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Nutrition Counseling",
        icon: <Zap size={28} />,
        desc: "Personalized dietary recommendations for optimal body condition, energy, and long-term organ health.",
        specs: ["Body Condition Score", "Diet Planning", "Weight Management", "Supplement Guidance"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Preventive",
    sectionItalic: "Programs.",
    warningTitle: "Why Prevention",
    warningItalic: "Is Priority.",
    warningText: "Prevention is always more cost-effective and less traumatic than treatment. An ounce of prevention protects your pet's quality of life for years.",
    warnings: [
      { name: "Missed Vaccinations", desc: "Lapsed vaccine schedules leave pets exposed to preventable fatal diseases.", icon: "💉" },
      { name: "Parasite Overload", desc: "Uncontrolled parasites cause anemia, organ damage, and disease transmission.", icon: "🐛" },
      { name: "Weight Gain", desc: "Obesity is the leading preventable disease in pets with severe health consequences.", icon: "⚖️" },
      { name: "Dental Neglect", desc: "Poor dental hygiene leads to systemic infection affecting heart and kidneys.", icon: "🦷" },
    ],
    ctaBadge: "Preventive Medicine",
    ctaTitle: "The Prevention",
    ctaItalic: "Approach.",
    ctaText: "Our preventive care programs are designed by Dr. T Suresh Babu to provide layered, evidence-based protection for every life stage of your beloved pet.",
    ctaBtn: "Start a Prevention Plan",
    seoText: "Comprehensive preventive pet care in Hyderabad. Parasite prevention, annual health screenings, and nutrition counseling at Dr. Suresh Pet Care.",
    glowColor: "green-500"
  };

  return (
    <>
      <SEO 
        title="Preventive Pet Healthcare"
        description="Comprehensive preventive care programs for pets at Dr. Suresh Pet Care, Hyderabad. Parasite control, nutrition counseling, and regular health screenings."
        canonical="/preventive-care"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default PreventiveCarePage;
